import React, { useState } from "react";
import GameController from './GameController';
import Status from './Status';
import Settings from './settings/Settings';
import { requestNewGame } from './apiClient';

const GameLayout = props => {
  
  const [ gameOver,      setGameOver ]      = useState(true);
  const [ gameType,      setGameType ]      = useState('notes');
  const [ clef,          setClef ]          = useState('treble');
  const [ kee,           setKee ]           = useState('C');
  const [ questionCount, setQuestionCount ] = useState(20);
  const [ timeLimit,     setTimeLimit ]     = useState(0);
  const [ correct,       setCorrect ]       = useState(0);
  const [ incorrect,     setIncorrect ]     = useState(0);
  const [ remaining,     setRemaining ]     = useState(0);
  const [ game,          setGame ]          = useState();
  const [ question,      setQuestion ]      = useState();

  const gamePropertySetters = {
    gameTypeSetter:      v => setGameType(v),
    clefSetter:          v => setClef(v),
    keeSetter:           v => setKee(v),
    questionCountSetter: v => setQuestionCount(v),
    timeLimitSetter:     v => setTimeLimit(v),
    correctSetter:       v => setCorrect(v),
    incorrectSetter:     v => setIncorrect(v),
    remainingSetter:     v => setRemaining(v),
    gameOverSetter:      v => setGameOver(v),
  };

  const startNewGame = () => {
    // console.log(gameType);
    // console.log(clef);
    // console.log(kee);
    // console.log(questionCount);
    // console.log(timeLimit);
    requestNewGame({ gameType:gameType, clef:clef, kee:kee, questionCount:questionCount, timeLimit:timeLimit }, processNewGameResponse);
  }

  function processNewGameResponse(game, question) {
    setGame(game);
    setQuestion(question);
    setGameOver(false);
    setCorrect(0);
    setIncorrect(0);
    setRemaining(game.questionCount);
  }

  if (gameOver) {
    return (
      <div className="game-layout">
        <table className="game-layout-table">
          <tbody>
            <tr className="status-row"><td><Status game={game} correct={correct} incorrect={incorrect} remaining={remaining} /></td></tr>
            <tr>
              <td>
                <Settings
                  gamePropertySetters={gamePropertySetters}
                  startNewGameCallback={startNewGame}
                  gameType={gameType}
                  clef={clef}
                  kee={kee}
                  questionCount={questionCount}
                  timeLimit={timeLimit}
                /> 
              </td>
            </tr>
            <tr align="center"><td> <button className="new-game-button" onClick={startNewGame}> New Game </button> </td></tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="game-layout">
      <table className="game-layout-table">
        <tbody>
          <tr className="status-row">
            <td>
              <GameController
                gamePropertySetters={gamePropertySetters}
                game={game}
                question={question}
                correct={correct}
                incorrect={incorrect}
                remaining={remaining}
                timeLimit={timeLimit}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

}

export default GameLayout;

